const regular = 400
const medium = 500
// const semibold = 600

export const fontLists = [
  {
    font: 'h1',
    size: 34,
    sizeLg: 34,
    fontWeight: medium,
  },
  {
    font: 'h1_lp', //landing_page
    size: 24,
    sizeLg: 34,
    fontWeight: medium,
  },
  {
    font: 'h2',
    size: 24,
    sizeLg: 24,
    fontWeight: medium,
  },
  {
    font: 'h3',
    size: 20,
    sizeLg: 20,
    fontWeight: medium,
  },
  {
    font: 'h4',
    size: 16,
    sizeLg: 16,
    fontWeight: medium,
  },
  {
    font: 'subtitle1',
    size: 14,
    sizeLg: 14,
    fontWeight: medium,
  },
  {
    font: 'subtitle2',
    size: 12,
    sizeLg: 12,
    fontWeight: medium,
  },
  {
    font: 'body1',
    size: 14,
    sizeLg: 14,
    fontWeight: regular,
  },
  {
    font: 'body2',
    size: 12,
    sizeLg: 12,
    fontWeight: regular,
  },
  {
    font: 'caption',
    size: 12,
    sizeLg: 12,
    fontWeight: regular,
  },
  {
    font: 'bodyRegular', // task management font
    size: 16,
    sizeLg: 16,
    fontWeight: regular,
  }
]
